<template>
  <VideoPC v-if="isPc"></VideoPC>
  <div v-else class="video-page">
    <loading ref="loading" />
    <!-- 顶部 -->
    <div class="video-hero">
      <div class="video-header">
        <i class="cubeic-back" @click="goBack"></i>
        <h1 class="video-title">{{ name || '视频播放' }}</h1>
        <span class="video-placeholder"></span>
      </div>
    </div>
    <div class="video-player-wrapper">
      <div id="mse" class="video-player"></div>
    </div>
    <div class="video-content" v-if="name">
      <div class="video-info-card">
        <div class="video-info-top">
          <div class="video-badge">正在播放</div>
        </div>
        <h2 class="video-name">{{ name }}</h2>
        <div class="video-meta">
          <span class="video-meta-item">
            <span class="meta-dot"></span>
            视频课程
          </span>
          <span class="video-meta-item">
            <span class="meta-dot"></span>
            在线学习
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { get_video_info } from "@/api/category";
import Player from 'xgplayer';
import 'xgplayer-mp4';
import loading from "@/views/loading";
import VideoPC from "./VideoPC.vue";
import {get_video_info} from "@/api/category";
import request from "@/utils/request";

export default {
  components: { loading, VideoPC },
  data () {
    return {
      address: '',
      name: '',
      videoinfo: [], // 视频详情
      isPc: false
    };
  },
  created () {
    this.isPc = this.IsPCVisted();
    if (this.isPc) return;
    // 获取视频
    // const {
    //   data: { data: video }
    // } = await get_video_info(this.$route.params.id);
    // this.videoinfo = video[0]; //console.log(this.videoinfo);
    //this.address = `/api/users/videos?id=${this.$route.params.id}`;
    //this.address = data.address;
    this.$nextTick(async () => {
      document.oncontextmenu = function () {
        return false;
      }
      if (this.$route.params.type === '1') {
        try {
          const {
            status, data
          } = await get_video_info(this.$route.params.id);
          if (status === 200) {
            const selfAddress = `https://cdn.lxtech528.cn${data.data[0].address}`;
            this.name = data.data[0].name;
            this.recordProgress();
              const player = new Player({
                el: document.querySelector('#mse'),
                url: selfAddress || '',
                videoInit: true,
                fluid: true,
                height: 0.8,
                width: 1,
                playbackRate: [0.75, 1, 1.5, 2],
                defaultPlaybackRate: 1,
                controlsList: ['nodownload'],
                preloadTime: 10,
                closeVideoClick: true,    // PC端：关闭单击暂停/播放
                closeVideoTouch: true,    // 移动端：关闭触摸松开(touchend)暂停/播放
                closeVideoDblclick: true,  // 可选：关闭双击全屏
                playsinline: true
              });
              var self = this;
              player.once('ready', function () {
                if (self.$refs && self.$refs['loading'] && self.$refs['loading'].hidePopups) {
                  self.$refs['loading'].hidePopups();
                }
              });

              // iOS: 拦截全屏按钮点击（含 touch 事件），使用 webkitEnterFullscreen 实现原生横屏全屏
              var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
              if (isIOS && player.video && player.video.webkitEnterFullscreen) {
                var container_ = document.querySelector('#mse');
                if (container_) {
                  var iosFullscreen = function (e) {
                    if (e.target.closest('.xgplayer-fullscreen') || e.target.closest('.xgplayer-cssfullscreen')) {
                      e.stopPropagation();
                      e.preventDefault();
                      var video_ = player.video;
                      video_.removeAttribute('playsinline');
                      video_.webkitEnterFullscreen();
                      // 退出全屏时恢复 playsinline，防止再次点播放自动全屏
                      var restore = function () {
                        if (!video_.webkitDisplayingFullscreen) {
                          video_.setAttribute('playsinline', '');
                          video_.removeEventListener('webkitendfullscreen', restore);
                        }
                      };
                      video_.addEventListener('webkitendfullscreen', restore);
                    }
                  };
                  container_.addEventListener('click', iosFullscreen, true);
                  container_.addEventListener('touchstart', iosFullscreen, true);
                  container_.addEventListener('touchend', iosFullscreen, true);
                }
              }
              }
        } catch (err) {
          this.$createToast({
            txt: err,
            type: "error",
            time: 1500
          }).show();
          setTimeout(() => {
            this.$router.push("/login");
          }, 1500)
        }
      }
    });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    recordProgress() {
      request({
        url: '/api/users/progress',
        method: 'post',
        data: {
          video_id: this.$route.params.id,
          video_name: this.name,
          category_id: this.$route.query.categoryId || ''
        }
      }).catch(() => {
        // 记录失败不影响视频播放
      });
    },
    IsPCVisted() {
      if (window.innerWidth < 768) return false;
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod", "Mobi", "Mobile"];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) !== -1) return false;
      }
      return true;
    }
  }
};
</script>

<style scoped>
.video-page {
  background: #f4f6fb;
  min-height: 100vh;
  padding-bottom: 30px;
}

/* ---- 顶部 ---- */
.video-hero {
  background: linear-gradient(135deg, #1a1a2e, #0f3460);
  padding: 16px;
  position: relative;
}

.video-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.video-header .cubeic-back {
  font-size: 22px;
  color: rgba(255, 255, 255, 0.85);
  padding: 4px 8px 4px 0;
}

.video-title {
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  letter-spacing: 0.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70%;
}

.video-placeholder {
  width: 30px;
}

/* ---- 播放器 ---- */
.video-player-wrapper {
  background: #000;
}

.video-player {
  width: 100%;
  min-height: 240px;
}

/* ---- 视频内容区 ---- */
.video-content {
  padding: 0 16px;
  margin-top: -10px;
  position: relative;
  z-index: 2;
}

.video-info-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px 18px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;
}

.video-info-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #764ba2);
}

.video-info-top {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.video-badge {
  font-size: 11px;
  color: #667eea;
  background: #eef0ff;
  padding: 3px 12px;
  border-radius: 12px;
  font-weight: 500;
}

.video-name {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 14px;
  line-height: 1.4;
}

.video-meta {
  display: flex;
  gap: 16px;
}

.video-meta-item {
  font-size: 13px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 6px;
}

.meta-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
}
</style>